import { castArray, includes, some } from 'lodash';
import Authentication from '@/mixins/Authentication';
import Combobox from '@/components/Combobox';
import Input from '@/mixins/Input';
import Progress from '@/mixins/Progress';

const extractRootName = function extractRootName(query) {
  if (!query) return null;
  const definition = query.definitions.find(d => d.operation === 'query');
  if (!definition) return null;
  return definition.selectionSet.selections[0].name.value;
};

export default (mixinOptions = {}) => {
  const extractEntries = (data) => {
    const rootName = extractRootName(mixinOptions.searchQuery);
    if (!rootName) return [];
    return data[rootName].entries;
  };

  return {
    mixins: [
      Authentication,
      Input,
      Progress,
    ],
    data() {
      return {
        search: null,
      };
    },
    props: {
      value: null,
      placeholder: String,
      multiple: {
        type: Boolean,
        default: false,
      },
      filter: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      Combobox,
    },
    computed: {
      hasValue() {
        if (!this.multiple) return !!this.internalValue;
        return this.internalValue && this.internalValue.length > 0;
      },
      selection() {
        return [];
      },
      options() {
        if (this.search) return this.filteredOptions;
        const options = (this.unfilteredOptions || []).slice(0);
        const values = castArray(this.internalValue || []);
        if (values.length) {
          const valueIds = values.map(value => value.id);
          const optionIds = options.map(option => option.id);
          if (!some(optionIds, id => includes(valueIds, id))) {
            values.forEach((value) => { options.unshift(value); });
          }
        }
        return options;
      },
      skipFilteredQuery() {
        return !this.search;
      },
      skipUnfilteredQuery() {
        return false;
      },
      skipAll() {
        return !this.isAuthenticated;
      },
    },
    apollo: {
      unfilteredOptions: {
        query: mixinOptions.searchQuery,
        variables() {
          return {
            filter: this.filter,
            pagination: { page: 1, size: 10 },
            sort: mixinOptions.unfilteredSort,
          };
        },
        result(result) {
          this.onResult(result);
        },
        skip() {
          return this.skipUnfilteredQuery;
        },
        fetchPolicy: 'network-only',
        loadingKey: 'loading',
        update: extractEntries,
      },
      filteredOptions: {
        query: mixinOptions.searchQuery,
        variables() {
          return {
            filter: this.filter,
            search: this.search,
            pagination: { page: 1, size: 50 },
            sort: mixinOptions.filteredSort,
          };
        },
        fetchPolicy: 'network-only',
        loadingKey: 'loading',
        debounce: 500,
        update: extractEntries,
        result(result) {
          this.onResult(result);
        },
        skip() {
          return this.skipFilteredQuery;
        },
      },
      $skipAll() {
        return this.skipAll;
      },
    },
    methods: {
      onInput(selections) {
        this.internalValue = selections;
        this.clearErrors();
        this.$emit('input', selections);
        this.$emit('change', selections);
      },
      onSearch(term) {
        this.search = term;
      },
      onClose() {
        this.search = null;
      },
      onResult() {
      },
      focus() {
        this.$refs.primaryInput.focus();
      },
      blur() {
        this.$refs.primaryInput.blur();
      },
    },
  };
};



// WEBPACK FOOTER //
// ./mixins/ResourceCombobox.js